export const MOCK_METER_READINGS = {
  results: [
    {
      value: 360,
      read_by: 'Eigentümer',
      reason: 'Einzug',
      meter_id: '6f4f9267-3372-4602-a542-babbe0515c03',
      counter_id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
      direction: 'feed-out',
      timestamp: '2024-12-31T23:00:00Z',
      source: '360',
      status: ''
    },
    {
      value: 580,
      read_by: 'Mieter',
      reason: 'Zwischenstand',
      meter_id: '6f4f9267-3372-4602-a542-babbe0515c03',
      counter_id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
      direction: 'feed-out',
      timestamp: '2025-01-30T23:00:00Z',
      source: '360',
      status: ''
    },
    {
      value: 795,
      read_by: 'Mieter',
      reason: 'Zwischenstand',
      meter_id: '6f4f9267-3372-4602-a542-babbe0515c03',
      counter_id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
      direction: 'feed-out',
      timestamp: '2025-02-27T23:00:00Z',
      source: '360',
      status: ''
    },
    {
      value: 1025,
      read_by: 'Mieter',
      reason: 'Zwischenstand',
      meter_id: '6f4f9267-3372-4602-a542-babbe0515c03',
      counter_id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
      direction: 'feed-out',
      timestamp: '2025-03-30T22:00:00Z',
      source: '360',
      status: ''
    },
    {
      value: 1265,
      read_by: 'Mieter',
      reason: 'Zwischenstand',
      meter_id: '6f4f9267-3372-4602-a542-babbe0515c03',
      counter_id: 'd52b8eed-3cf6-40a7-927e-02d65b34cd7c',
      direction: 'feed-out',
      timestamp: '2025-04-29T22:00:00Z',
      source: '360',
      status: ''
    }
  ],
  hits: 5
}
